import { ConfigService } from './../../../services/config.service';
import { ReadableDisplayEnum } from '../../../../submodules/silverlight-common/lib/ts/src/common-enums/readable.display.enums';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { plmUserRoleEnum } from '../../../../submodules/silverlight-common/lib/ts/src/common-enums/user.role.enums';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { CustomDateFormatPipe } from '../../../pipes/date-format-pipe';
import UIConstants from '../../../../app-constants/ui-constants';
import { IConfigData } from '../../../../submodules/silverlight-common/lib/ts/src/interface/config.data.interface';
@Component({
  selector: 'app-view-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatCheckboxModule,
    CustomDateFormatPipe,
  ],
  templateUrl: './view-modal.component.html',
  styleUrl: './view-modal.component.scss',
})
export class viewModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private configService: ConfigService) {
    console.log('data', data);
  }
  ngOnInit(): void {
    this.configService.configData$.subscribe((data) => {
      if (data) {
        const configDataJson = data?.find((config: IConfigData) => {
          return config?.keyName === 'InjectorTypes';
        })
          ?.keyValue
        const configDataObject = JSON.parse(configDataJson ?? '');
        this.productTypeObject = configDataObject
      }
    })
  }
  productTypeObject:any = {}
  columns = Object.keys(this.data);
  viewModalConstants = UIConstants.View_Modal;
  readableDisplayEnum = ReadableDisplayEnum;
  userAssignedRoleEnum = plmUserRoleEnum;
  get userProductTypeArray(): string[]{
    return this.data.userProductTypes.map((product:string) => this.productTypeObject?.[product] ?? product)
  }
  shouldRowBeDisplayed(key: string): boolean {
    return key in this.readableDisplayEnum;
  }
}
